interface IProp {
  className?: string
}

const GPSRequired = (props: IProp) => {
  const { className = 'fill-none stroke-black' } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 2L2 7.50437H8.25C8.3163 7.50437 8.37989 7.53071 8.42678 7.5776C8.47366 7.62448 8.5 7.68807 8.5 7.75437V14L14 2Z"
        className={className}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default GPSRequired
